import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  useEffect,
} from 'react';

import { useAuth } from '~/context/AuthContext';
import { default as api } from '~/services/api2';

const MenuContext = createContext();

const MenuProvider = ({ children }) => {
  const [menu, setMenu] = useState([]);
  const [productsFiltered, setProductsFiltered] = useState();

  const [categoryState, setCategoryState] = useState();

  const { user } = useAuth();
  const userId = user?.restaurant_id || user?.id;

  const handleSearchInputEanProduct = useCallback(
    async (data, isTableDelivery) => {
      if (data.length < 3) {
        setProductsFiltered({ products: [] });
        return;
      }

      try {
        const normalizedData = normalizeString(data);

        const productFind = menu.map((cat) =>
          cat.products
            .map((prod) => {
              const isMatchByName = normalizeString(prod.name).includes(
                normalizedData
              );
              const isMatchByEan = prod.ean_codes?.some(
                (ean) =>
                  normalizeString(ean).includes(normalizedData) &&
                  ean.length <= 7
              );

              if (isTableDelivery) {
                return isMatchByName && prod.available_in_delivery
                  ? { prod, cat }
                  : '';
              }
              return (isMatchByName || isMatchByEan) && prod.available
                ? { prod, cat }
                : '';
            })
            .filter((item) => item !== '')
        );

        const arrayReady = productFind.filter((arr) => arr.length > 0);

        setProductsFiltered(arrayReady);
      } catch (error) {
        console.log('Produto não encontrado!');
      }
    },
    [menu] // 🔹 Só recria a função se o menu mudar
  );

  function searchScaleCode(code, isTableDelivery) {
    function extractScaleCode(barcode) {
      if (!barcode || barcode.length < 8) return null;

      const trimmed = barcode.slice(1);

      const scaleCode = trimmed.slice(0, 6);

      return scaleCode;
    }

    let newScannerBarcode = code;

    const extractedCode = extractScaleCode(newScannerBarcode);
    if (extractedCode) {
      newScannerBarcode = extractedCode;
    }

    handleSearchInputEanProduct(newScannerBarcode, isTableDelivery);
  }

  const normalizeString = (str) =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const handleSearchInputProduct = useCallback(
    async (data, isTableDelivery) => {
      if (data.length < 3) {
        setProductsFiltered({ products: [] });
        return;
      }

      try {
        const normalizedData = normalizeString(data);

        const productFind = menu.map((cat) =>
          cat.products
            .map((prod) => {
              const isMatchByName = normalizeString(prod.name).includes(
                normalizedData
              );
              const isMatchByEan = prod.ean_codes?.some((ean) =>
                normalizeString(ean).includes(normalizedData)
              );

              if (isTableDelivery) {
                return isMatchByName && prod.available_in_delivery
                  ? { prod, cat }
                  : '';
              }
              return (isMatchByName || isMatchByEan) && prod.available
                ? { prod, cat }
                : '';
            })
            .filter((item) => item !== '')
        );

        const arrayReady = productFind.filter((arr) => arr.length > 0);

        if (arrayReady.length === 0 && user.ean_scale_code !== 'none') {
          searchScaleCode(data, isTableDelivery);
          return;
        }
        setProductsFiltered(arrayReady);
      } catch (error) {
        console.log('Produto não encontrado!');
      }
    },
    [menu] // 🔹 Só recria a função se o menu mudar
  );

  const handleChangeCategory = useCallback(
    async (categoryName) => {
      // const response = await api.get(`/public/restaurants/menu/${userId}`);
      const categoryFiltered = menu.filter((cat) => cat.name === categoryName);

      setProductsFiltered('');

      setCategoryState(categoryFiltered[0]);
    },
    [menu]
  );

  const updateMenuCategory = useCallback(
    (id, data) => {
      const category = menu.find((c) => c.id === id);

      if (category) {
        Object.keys(data).forEach((k) => {
          category[k] = data[k];
        });
      }
    },
    [menu]
  );

  const getMenu = useCallback(
    async (userScreenTop) => {
      const response = await api.get(
        `/public/restaurants/menu/${userId}?menuTable=true`
      );
      setMenu(response.data);

      const categoryNotEmptyPdv = response.data.filter((cat) => cat.available);

      const categoryNotEmptyDelivery = response.data.filter(
        (cat) => cat.available_in_delivery
      );

      if (user.only_delivery) {
        setCategoryState(categoryNotEmptyDelivery[0]);
      } else {
        setCategoryState(categoryNotEmptyPdv[0]);
      }

      if (userScreenTop) {
        window.scroll({
          top: Number(userScreenTop),
          behavior: 'smooth',
        });
      }
    },
    [userId, user]
  );

  useEffect(() => {
    if (user?.id) {
      getMenu();
    }
  }, [getMenu, user]);

  const value = useMemo(
    () => ({
      handleChangeCategory,
      handleSearchInputProduct,
      productsFiltered,
      categoryState,
      menu,
      setProductsFiltered,
      getMenu,
      setCategoryState,
      setMenu,
      updateMenuCategory,
    }),
    [
      categoryState,
      productsFiltered,
      handleChangeCategory,
      setProductsFiltered,
      menu,
      getMenu,
      setMenu,
      setCategoryState,
      updateMenuCategory,
      handleSearchInputProduct,
    ]
  );

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

const useMenu = () => {
  const context = useContext(MenuContext);

  if (!context) {
    console.log('useCart must be within a provider');
  }

  return context;
};

export { MenuProvider, useMenu };
